module.exports = __webpack_public_path__ + "static/media/24UHCHR25.40d109c9.jpg";